export default __webpack_public_path__ + "static/media/rstore.78124df0.png";